// extracted by mini-css-extract-plugin
module.exports = {"DialogContent":"SelectFarmDialog_DialogContent__8hBly","narrow-scrollbar":"SelectFarmDialog_narrow-scrollbar__1o99q"};